// Shared status constants + color mapping used across the admin Orders and
// Repair Intakes tabs.

export const ORDER_STATUSES = ["pending", "paid", "shipped", "delivered", "cancelled", "refunded"];
export const INTAKE_STATUSES = ["new", "contacted", "in_progress", "completed", "cancelled"];

export function statusColor(s) {
  const map = {
    pending: "bg-amber-100 text-amber-800",
    paid: "bg-blue-100 text-blue-800",
    shipped: "bg-indigo-100 text-indigo-800",
    delivered: "bg-emerald-100 text-emerald-800",
    cancelled: "bg-zinc-100 text-zinc-600",
    refunded: "bg-zinc-100 text-zinc-600",
    new: "bg-brand text-white",
    contacted: "bg-blue-100 text-blue-800",
    in_progress: "bg-amber-100 text-amber-800",
    completed: "bg-emerald-100 text-emerald-800",
  };
  return map[s] || "bg-zinc-100 text-zinc-600";
}
